export const MENTION_USER_LABEL_CLASSNAME = 'sendbird-mention-user-label';
